import { forwardRef, useEffect, useState } from "react";

import { cn } from "@/lib/utils";

import { BackIcon, TopIcon } from "./icons";

interface DefaultAvatarProps {
  className?: string;
  size?: number;
  word: string;
}

export default forwardRef<HTMLDivElement, DefaultAvatarProps>(
  function DefaultAvatar({ className, word, size = 42 }, ref) {
    const [offset, setOffset] = useState<[number, number]>([0, 0]);

    useEffect(() => {
      const getLayerOffset = (distance = 1.8): [number, number] => {
        const theta =
          (Math.floor(Math.random() * Number.MAX_SAFE_INTEGER) /
            (Number.MAX_SAFE_INTEGER - 1)) *
          Math.PI *
          2;

        return [
          Math.round(distance * Math.cos(theta)),
          Math.round(distance * Math.sin(theta)),
        ];
      };

      setOffset(getLayerOffset());
    }, []);

    return (
      <div
        className={cn("relative size-(--box-size)", className, "border-0")}
        ref={ref}
        style={
          {
            "--box-size": `${size}px`,
            "--font-size": `${size / 2 / 16}rem`,
          } as React.CSSProperties
        }
      >
        <p className="text-(length:--font-size) flex size-full items-center justify-center rounded-full bg-rich-black font-medium text-shadow-0-0-2 text-shadow-white/80 text-white uppercase">
          {word.slice(0, 1)}
        </p>
        <BackIcon
          className="absolute top-(--top) left-(--left) size-(--box-size)"
          style={
            {
              "--left": `${offset[0]}px`,
              "--top": `${offset[1]}px`,
            } as React.CSSProperties
          }
        />
        <TopIcon className="absolute top-0 left-0 size-(--box-size)" />
      </div>
    );
  }
);
